module.exports = __webpack_public_path__ + "static/media/cashflow-keep-btn-selected.4ea09ee9.svg";